export default __webpack_public_path__ + "static/Certificate-dc2b719c08373a91235d30bc918bca0e.png";